import { storyblokEditable } from "@storyblok/react";
import { Link, List } from "@mui/material";
import Grid from "@mui/material/Grid2";
import NavigationListItem from "./NavigationListItem";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import CustomButton from "components/Button";

interface INavigationProps {
  blok: { category_name: string; items: any };
}

const NavigationList = ({ blok }: INavigationProps) => {
  const { t, i18n } = useTranslation();
  const navigate = useNavigate();
  const local = i18n.language;
  const firstFivePosts = blok?.items.slice(0, 5) || [];
  return blok?.items?.length ? (
    <Grid size={{ xs: 12, md: 6, lg: 4 }} {...storyblokEditable(blok)} sx={{ padding: "16px" }}>
      <Link
        component="h2"
        underline="none"
        sx={{
          width: "fit-content",
          marginBottom: "16px",
          padding: "6px 24px",
          color: "#FFFFFF",
          fontSize: "24px",
          fontWeight: 500,
          lineHeight: "32px",
          borderRadius: "16px",
          backgroundColor: "#F4701B",
          transition: "color 0.3s ease",
          "&:hover": { backgroundColor: "#F0670B" },
          cursor: "pointer",
        }}
        onClick={() => {
          navigate(`/blog/${local}/${blok.category_name}`);
        }}
      >
        {t(blok.category_name)}
      </Link>
      <List dense={false} sx={{ display: "flex", flexDirection: "column", gap: "12px", padding: 0 }}>
        {firstFivePosts.map((blok: any, index: any) => (
          <NavigationListItem key={blok.uuid || index} blok={blok} />
        ))}
      </List>
      {blok?.items?.length > 5 ? (
        <CustomButton
          width={"max-content"}
          height={30}
          textButton={t("more")}
          customColor="#F4701B"
          customFontSize="12px"
          customMargin="10px 0px 0px 0px"
          customPadding="8px 24px"
          customTextTransform="none"
          onClick={() => navigate(`/blog/${local}/${blok.category_name}`)}
        />
      ) : null}
    </Grid>
  ) : null;
};

export default NavigationList;
